const BASE_MS = 1_000
const MAX_MS = 16_000

/** Reconnect delay for the n-th consecutive failure (0-based): 1 s, 2 s, 4 s, 8 s, 16 s, 16 s, … */
export function backoffMs(attempt: number): number {
  return Math.min(MAX_MS, BASE_MS * 2 ** attempt)
}
